

import {httpservice} from '../services';
import {constants} from '../constant/constant';

export default isEnabled => {
    return httpservice()
        .post(isEnabled ? constants.API.ENABLE_TWO_FA : constants.API.DISABLE_TWO_FA)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error.response.data;
        });
};